/**
 * Paleta categorica de graficos.
 *
 * Los valores viven en `index.css` como tokens (`--chart-1`..`--chart-4`) para
 * que el modo oscuro los cambie solo. Aca solo estan los NOMBRES, en su orden
 * fijo.
 *
 * EL ORDEN NO SE CICLA NI SE REORDENA. Una serie conserva su color aunque un
 * filtro cambie cuantas se ven: si al filtrar se repintan las supervivientes, el
 * lector cree que cambio el dato. Y una novena serie no genera un tono nuevo —
 * se agrupa en "Otros" o se parte en varios graficos.
 */
export const SERIES = ["chart-1", "chart-2", "chart-3", "chart-4"] as const

export type SerieColor = (typeof SERIES)[number]

/** Color de la serie n (0-indexada), como valor CSS listo para usar. */
export function colorSerie(indice: number): string {
  const token = SERIES[indice] ?? SERIES[SERIES.length - 1]
  return `hsl(var(--${token}))`
}

/** El mismo color con alfa, para rellenos bajo una linea. */
export function colorSerieSuave(indice: number, alfa = 0.12): string {
  const token = SERIES[indice] ?? SERIES[SERIES.length - 1]
  return `hsl(var(--${token}) / ${alfa})`
}
